<template>
  <el-dialog v-bind="$attrs" custom-class="my-dialog">
    <img
      class="closeBtn"
      src="@/assets/images/close1.png"
      @click="$emit('update:visible', false)"
    />
    <img :src="screen.image" alt="" />
    <div
      class="btn"
      @click="
        $emit('noShow', false);
        $emit('update:visible', false);
      "
    >
      今日不再显示
    </div>
  </el-dialog>
</template>


<script>
export default {
  props: {
    screen: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/main/home/components/home-dialog.vue